import { Card, EncabezadoPaginaSkeleton, FormSkeleton, RegionCargando, Skeleton, TablaSkeleton } from "@/components/ui";

/**
 * Edición de un documento de compra (OC / CA) en carga · mismo marco que
 * `AdminEditarContratoPage` / `AdminEditarOrdenCompraPage`: encabezado con
 * breadcrumbs y la tarjeta del formulario (8 campos en 4 columnas, proveedor,
 * observaciones, tabla de conceptos y acciones). `pendingComponent` de ambas rutas.
 */
export function EditarDocumentoCompraSkeleton() {
  return (
    <RegionCargando etiqueta="Cargando documento…" className="mx-auto max-w-7xl px-4 py-8 md:px-6">
      <EncabezadoPaginaSkeleton conBreadcrumbs />
      <Card padding="lg" aria-hidden="true">
        <div className="flex flex-col gap-4">
          <Skeleton height={16} width={240} />
          <FormSkeleton campos={8} columnas={4} />
          <FormSkeleton campos={3} columnas={3} />
          <FormSkeleton campos={1} columnas={1} />
          <Skeleton height={10} width={90} className="mx-auto" />
          <TablaSkeleton columnas={[{ w: 1 }, { w: 3 }, { w: 1, align: "right" }, { w: 1 }, { w: 1.2, align: "right" }]} filas={4} />
          <div className="flex justify-end gap-2">
            <Skeleton height={36} width={110} />
            <Skeleton height={36} width={150} />
          </div>
        </div>
      </Card>
    </RegionCargando>
  );
}
